import { f as r } from "./function-uncurry-this.js";
import { a as o } from "./a-callable.js";
import { i as t } from "./is-object.js";
import { h as n } from "./has-own-property.js";
import { a as i } from "./array-slice.js";
import { f as a } from "./function-bind-native.js";
var s = Function,
  f = r([].concat),
  e = r([].join),
  p = {},
  c = function c(r, o, t) {
    if (!n(p, o)) {
      for (var i = [], a = 0; a < o; a++) i[a] = "a[" + a + "]";
      p[o] = s("C,a", "return new C(" + e(i, ",") + ")");
    }
    return p[o](r, t);
  },
  u = a ? s.bind : function (r) {
    var n = o(this),
      a = n.prototype,
      s = i(arguments, 1),
      e = function e() {
        var o = f(s, i(arguments));
        return this instanceof e ? c(n, o.length, o) : n.apply(r, o);
      };
    return t(a) && (e.prototype = a), e;
  };
export { u as f };